export default () => {
  //Olw carousel initialization:
  function kioscoCarousel() {
    $('#owl-kiosko').owlCarousel({
      center: false,
      loop: false,
      nav: true,
      navText: ["<i class='fal fa-chevron-left'></i>", "<i class='fal fa-chevron-right'></i>"],
      responsive: {
        360: {
          stagePadding: 52.5,
          items: 2
        },
        768: {
          stagePadding: 45.5,
          items: 5
        },
        1040: {
          stagePadding: 0,
          items: 2
        }
      }
    });
  }

  $(window).resize(function() {
    $('#owlKiosko').trigger("destroy.owl.carousel");
    setTimeout(kioscoCarousel(), 300);
  });

  kioscoCarousel();
}
